// Generated by ReScript, PLEASE EDIT WITH CARE

import * as HomeAtoms from "../../atoms/home/HomeAtoms.re.mjs";
import * as Core from "@linaria/core";
import * as JsxRuntime from "react/jsx-runtime";
import Hero_480Mp4 from "../../molecules/home/hero_480.mp4";
import Hero_720Mp4 from "../../molecules/home/hero_720.mp4";
import Hero_1080Mp4 from "../../molecules/home/hero_1080.mp4";
import Hero_480Webm from "../../molecules/home/hero_480.webm";
import Hero_720Webm from "../../molecules/home/hero_720.webm";
import Hero_1080Webm from "../../molecules/home/hero_1080.webm";
import Hero_posterJpg from "../../molecules/home/hero_poster.jpg";

import { css, cx } from '@linaria/core'
;

import { t } from '@lingui/macro'
;

let heroPoster = Hero_posterJpg;

let hero1080Webm = Hero_1080Webm;

let hero1080Mp4 = Hero_1080Mp4;

let hero720Webm = Hero_720Webm;

let hero720Mp4 = Hero_720Mp4;

let hero480Webm = Hero_480Webm;

let hero480Mp4 = Hero_480Mp4;

let revealTiming = (css`
  --hero-reveal-delay: 4.6s;
  --hero-reveal-duration: 1s;
`);

let scrimFadeIn = (css`
  opacity: 0;
  animation: heroScrimIn var(--hero-reveal-duration) ease-out var(--hero-reveal-delay) forwards;
  @keyframes heroScrimIn {
    to { opacity: 1; }
  }
  @media (prefers-reduced-motion: reduce) {
    animation-duration: 0.01s;
    animation-delay: 0s;
  }
`);

let descriptionInvert = (css`
  animation: heroDescriptionInvert var(--hero-reveal-duration) ease-out var(--hero-reveal-delay) forwards;
  @keyframes heroDescriptionInvert {
    to { color: #e9e9e7; }
  }
  @media (prefers-reduced-motion: reduce) {
    animation-duration: 0.01s;
    animation-delay: 0s;
  }
`);

let ctaInvert = (css`
  animation: heroCtaInvert var(--hero-reveal-duration) ease-out var(--hero-reveal-delay) forwards;
  @keyframes heroCtaInvert {
    to {
      color: #e9e9e7;
      border-color: #e9e9e7;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    animation-duration: 0.01s;
    animation-delay: 0s;
  }
`);

function HeroSection(props) {
  return JsxRuntime.jsxs("section", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("video", {
            children: [
              JsxRuntime.jsx("source", {
                media: "(min-width:1280px)",
                src: hero1080Webm,
                type: "video/webm"
              }),
              JsxRuntime.jsx("source", {
                media: "(min-width:1280px)",
                src: hero1080Mp4,
                type: "video/mp4"
              }),
              JsxRuntime.jsx("source", {
                media: "(min-width:640px)",
                src: hero720Webm,
                type: "video/webm"
              }),
              JsxRuntime.jsx("source", {
                media: "(min-width:640px)",
                src: hero720Mp4,
                type: "video/mp4"
              }),
              JsxRuntime.jsx("source", {
                src: hero480Webm,
                type: "video/webm"
              }),
              JsxRuntime.jsx("source", {
                src: hero480Mp4,
                type: "video/mp4"
              }),
              t`Your browser does not support the video tag.`
            ],
            className: Core.cx("w-full h-full object-cover object-left"),
            autoPlay: true,
            loop: true,
            muted: true,
            playsInline: true,
            poster: heroPoster
          }),
          JsxRuntime.jsx("div", {
            "aria-hidden": true,
            className: Core.cx(scrimFadeIn, "absolute inset-0 pointer-events-none bg-black/45 md:bg-transparent md:bg-gradient-to-r md:from-black/60 md:via-black/40 md:to-transparent")
          })
        ],
        className: Core.cx("absolute inset-0 w-full h-full bg-[#e9e9e7]")
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs(HomeAtoms.SerifHeading.make, {
              level: 1,
              children: [
                JsxRuntime.jsx("span", {
                  children: t`Photo to Painting`,
                  className: Core.cx("inline-block text-[#d5d5d2]")
                }),
                JsxRuntime.jsx("span", {
                  children: t`on Canvas`,
                  className: Core.cx("text-xl md:text-2xl tracking-widest font-light block -mt-2 text-[#d5d5d2]")
                })
              ],
              className: Core.cx("text-4xl md:text-6xl lg:text-7xl mb-4")
            }),
            JsxRuntime.jsx("p", {
              children: t`Turn your photo into a custom painting on canvas made by a professional artist. Ready to ship in as little as 7 days.`,
              className: Core.cx(descriptionInvert, "max-w-md mx-auto md:mx-0 mb-8 text-sm md:text-base font-light text-gray-800")
            }),
            JsxRuntime.jsx("a", {
              children: t`Discover More`,
              className: Core.cx(ctaInvert, "inline-block bg-transparent hover:bg-gray-800/10 border border-gray-800 px-8 py-3 rounded-none transition-all duration-300 text-sm tracking-wide font-light text-gray-800"),
              href: "#choose-medium"
            })
          ],
          className: Core.cx("max-w-md text-center md:text-left md:self-start")
        }),
        className: Core.cx("relative h-full flex flex-col justify-center items-center px-6 md:px-16 lg:px-24")
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            className: Core.cx("w-px h-16 mx-auto bg-gray-800")
          }),
          JsxRuntime.jsx("p", {
            children: t`SCROLL`,
            className: Core.cx("text-xs tracking-widest mt-2 text-center font-light text-gray-800")
          })
        ],
        className: Core.cx("absolute bottom-8 left-1/2 transform -translate-x-1/2")
      })
    ],
    className: Core.cx(revealTiming, "relative h-screen w-full overflow-hidden")
  });
}

let make = HeroSection;

export {
  heroPoster,
  hero1080Webm,
  hero1080Mp4,
  hero720Webm,
  hero720Mp4,
  hero480Webm,
  hero480Mp4,
  revealTiming,
  scrimFadeIn,
  descriptionInvert,
  ctaInvert,
  make,
}
/*  Not a pure module */
